import { useContext } from 'react';
import { ChatSidebarContext } from './ChatSidebarProvider';

export const useChatSidebar = () => useContext(ChatSidebarContext);
